import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(() => ({
  container: {
    textAlign: 'center',
    padding: `${rem(8)} ${rem(12)}`,
    borderRadius: rem(8),
    background:
      'linear-gradient(90deg, #78E77B 0%, #8DE7B0 50.5%, #3AE9A0 100%)',
  },
}));
